import { ValueGetterParams } from "ag-grid-community";
import { isHierarchyFolder } from "@/store/navigation/utils/helpers/isHierarchyFolder";

import { HierarchyFolderItem } from "@/store/navigation/utils/types";

export const hierarchyAllItemsVisibilityValueGetter = <
  T extends HierarchyFolderItem,
>({
  data,
}: ValueGetterParams<T>) => {
  if (!data?.visibility) {
    return;
  }

  return data.visibility === "visible_only_to_me" ? "Only me" : "Everyone";
};

export const hierarchyAllItemsNameValueGetter = <
  T extends HierarchyFolderItem,
>({
  data,
}: ValueGetterParams<T>) => {
  const isFolder = data && isHierarchyFolder(data);
  const itemsLength = isFolder ? `(${data.items?.length ?? 0})` : "";
  const protection = isFolder ? "" : data?.protection_details?.is_protected;
  const visibility = data?.visibility;
  const homePage = data && "is_home_page" in data && data.is_home_page;

  return `${data?.name ?? ""} ${itemsLength} ${protection} ${visibility} ${homePage}`;
};

export const hierarchyAllItemsNameFilterValueGetter = <
  T extends HierarchyFolderItem,
>({
  data,
}: ValueGetterParams<T>) => {
  return data?.name ?? "";
};
